// extracted by mini-css-extract-plugin
export default {"vnav":"vnav_vnav__zUc8i","sub_items":"vnav_sub_items__v610L"};